import { memo } from "react";
import { Collection } from "react-aria-components";
import { Airport } from "./airport";
import { ListBoxSection } from "@jetblue/kit/input-combobox";

export const Region = memo(
  ({
    inputValue,
    name,
    code,
    needle,
    cc,
  }: {
    inputValue?: string | undefined;
    name: string;
    needle: string;
    code: string;
    cc: {
      name: string;
      code: string;
      needle: string;
    }[];
  }) => (
    <ListBoxSection key={code}>
      <Airport
        code={code}
        inputValue={inputValue}
        name={name}
        needle={needle}
      />
      <Collection items={cc}>
        {({ name, needle, code }) => (
          <Airport
            code={code}
            indent
            inputValue={inputValue}
            name={name}
            needle={needle}
          />
        )}
      </Collection>
    </ListBoxSection>
  ),
);

Region.displayName = "Region";
